import React from 'react'
import { QRCodeSVG } from 'qrcode.react'

export default React.forwardRef((props, ref) => {
    return (
        <div ref={ref} style={{textAlign:'center',padding:'20px'}}>
            <div style={{fontWeight:'bold',fontSize:'18px',marginBottom:'10px'}}>
                {props.company}
            </div>
            <QRCodeSVG
                value={`${props.barCode}`}
                size={150}
                level={'H'}
                marginSize={4}
            />
            <div style={{fontSize:'18px',marginTop:'10px'}}>
                {props.name}
            </div>
        </div>
    )
})
